import { browserSupportsWebAuthn, WebAuthnError } from '@simplewebauthn/browser';

export { browserSupportsWebAuthn };

export const UNSUPPORTED =
  "This browser can't use passkeys. Please use an up-to-date Chrome, Safari or Edge.";

// The browser's own errors, in plain words (ops spec K step 11).
export const passkeyErrorMessage = (err: unknown): string => {
  const name = err instanceof WebAuthnError ? (err.cause as Error | undefined)?.name ?? err.name : (err as Error)?.name;
  if (name === 'NotAllowedError' || (err instanceof WebAuthnError && err.code === 'ERROR_CEREMONY_ABORTED')) {
    return 'The passkey prompt was cancelled or timed out. Try again.';
  }
  if (err instanceof WebAuthnError && err.code === 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED') {
    return 'This device already has a passkey for your account.';
  }
  return (err as Error)?.message || 'The passkey step failed. Try again.';
};
